import { render, staticRenderFns } from "./customDashboardCalendar.vue?vue&type=template&id=61e1f16b&scoped=true"
import script from "./customDashboardCalendar.vue?vue&type=script&lang=js"
export * from "./customDashboardCalendar.vue?vue&type=script&lang=js"
import style0 from "./customDashboardCalendar.vue?vue&type=style&index=0&id=61e1f16b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e1f16b",
  null
  
)

export default component.exports